
import React from 'react';
import { Sparkles, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Calendar } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const BeautyLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Sparkles,
      title: "Nossos Serviços",
      subtitle: "Tratamentos de beleza",
      url: "https://decidedigital.com.br/",
      gradient: "from-pink-400 via-rose-500 to-purple-600"
    },
    {
      icon: Calendar,
      title: "Agendar Online",
      subtitle: "Reserve seu horário",
      url: "https://decidedigital.com.br/",
      gradient: "from-purple-500 to-indigo-600"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Beleza",
      subtitle: "Consultoria personalizada",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20agendar%20um%20hor%C3%A1rio",
      gradient: "from-green-500 to-emerald-600"
    },
    {
      icon: Phone,
      title: "Telefone",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-blue-500 to-cyan-600"
    },
    {
      icon: Mail,
      title: "Contato",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-violet-500 to-purple-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-50 to-indigo-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-6 shadow-xl border border-pink-200 mb-6 animate-fade-in">
          <div className="text-center">
            <div className="w-28 h-28 mx-auto mb-4 bg-gradient-to-br from-pink-400 via-purple-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg">
              <Sparkles className="w-12 h-12 text-white" />
            </div>
            <h1 className="text-3xl font-bold bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent mb-2">
              Bella Estética
            </h1>
            <p className="text-gray-600 leading-relaxed px-4 text-sm">
              ✨ Studio de beleza e bem-estar. Tratamentos faciais, corporais e 
              procedimentos estéticos com tecnologia de ponta e profissionais especializados.
            </p>
          </div>
        </div>

        <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 mb-6 text-center border border-pink-100 animate-scale-in">
          <p className="text-gray-700 text-sm mb-3">💄 Catálogo de Serviços:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
          </div>
        </div>

        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-14 h-14 bg-white/70 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:shadow-xl link-button border border-pink-200 animate-scale-in animate-delay-${index * 100}`}
            >
              <social.icon className="w-6 h-6 text-pink-600" />
            </a>
          ))}
        </div>

        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-5 bg-gradient-to-r ${link.gradient} rounded-3xl text-white shadow-xl hover:shadow-2xl link-button animate-fade-in animate-delay-${index * 100}`}
            >
              <div className="flex items-center">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mr-4">
                  <link.icon className="w-7 h-7" />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
                <Sparkles className="w-5 h-5 opacity-70" />
              </div>
            </a>
          ))}
        </div>

        <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 mt-6 border border-pink-100 animate-fade-in">
          <p className="text-gray-700 text-sm mb-3 text-center font-medium">💆‍♀️ Nosso Studio:</p>
          <MapComponent 
            latitude={-8.7619} 
            longitude={-63.9019} 
            zoom={16}
            category="beauty"
            popupText="Bella Estética - Studio de Beleza"
          />
        </div>

        <div className="bg-gradient-to-r from-pink-500 via-rose-500 to-purple-600 rounded-3xl p-4 mt-4 text-white text-center animate-fade-in">
          <p className="font-bold text-sm">🎀 Cliente Nova - 20% OFF</p>
          <p className="text-xs opacity-90">No primeiro procedimento estético</p>
        </div>
      </div>
    </div>
  );
};

export default BeautyLinktree;
